import "@fontsource/noto-sans-tc/400.css";
import "@fontsource/noto-sans-tc/500.css";
import "@fontsource/noto-sans-tc/600.css";
import "@fontsource/noto-sans-tc/700.css";
import "@fontsource/pt-sans/400.css";
import "@fontsource/pt-sans/700.css";

import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade , Thumbs } from 'swiper/modules';
import 'swiper/css/bundle';
import "./js/brand-stores-list";
import './js/sweetalert';

Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Thumbs]);
window.Swiper = Swiper;

// JavaScript
$(document).ready( function () {
  //scroll top
  // $('.back-to-top').click(function(event){
  //   $("html,body").animate({scrollTop: 0}, 1000);
  // });

  // transparent header
  function headerScroll() {
    if ($(window).scrollTop() > 100) {
      $('.header').addClass("min-header");
    } else {
      $('.header').removeClass("min-header");
    }
  }
  headerScroll();
  $(window).on('scroll', function () {
    headerScroll();
  });

  $('.header-mobile-menu').on('click', function () {
    $(this).toggleClass('active');
    $('.header-menu-outer').toggleClass('active');
  });

  $('.menu-dropdown-toggle').on('click', function() {
    $(this).parent().toggleClass('active').siblings().removeClass('active');
  });

  // 首頁輪播
  if ( $('#indexBanner').length != 0 ) {
    var indexBanner = new Swiper('#indexBanner', {
      effect: 'fade',
      autoplay: {
        delay: 5000,
      },
      loop: true,
      speed: 1000,
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }

  // 彙總頁分類Tabs
  if ( $('#pageCateSwiper').length != 0 ) {
    var swiper = new Swiper("#pageCateSwiper", {
      slidesPerView: "auto",
      spaceBetween: 0,
      freeMode: true,
      watchOverflow: true,
      navigation: {
        nextEl: ".page-cate-group .swiper-button-next",
        prevEl: ".page-cate-group .swiper-button-prev",
      },
    });
    // 水平置中
    let totalWidth = 0;
    function setSwiperCenter() {
      totalWidth = 0;
      $('#pageCateSwiper .swiper-slide').each(function (index) {
        totalWidth += $(this).width();
        return totalWidth;
      });
      if ( $('#pageCateSwiper').width() > totalWidth ) {
        $('#pageCateSwiper .swiper-wrapper').css('justify-content', 'center');
      } else {
        $('#pageCateSwiper .swiper-wrapper').css('justify-content', 'flex-start');
      }
    }
    setSwiperCenter();
    let pageCateResizeTimer; // resize計時器
    $(window).on('resize', function() {
      clearTimeout(pageCateResizeTimer);
      pageCateResizeTimer = setTimeout(function () {
          setSwiperCenter();
      }, 300);
    });
  }

  // 產品內頁-產品輪播
  if ( $('#productSlider').length != 0 ) {
    // 產品縮圖輪播
    var productThumbsSlider = new Swiper("#productThumbsSlider", {
      observer: true, 
      observeParents: true,
      spaceBetween: 3,
      slidesPerView: 5,
      freeMode: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      allowTouchMove: false, // 停用觸控滑動
    });
    // 產品大圖輪播
    var productSlider = new Swiper("#productSlider", {
      observer: true, 
      observeParents: true,
      effect: 'fade',
      thumbs: {
        swiper: productThumbsSlider,
      },
    });
    // 產品大圖-電腦版游標移動的放大鏡功能
    $('#productSlider').on('mousemove', '.swiper-slide', function(e) {
      const $this = $(this);
      const $img = $this.find('img');
      const offset = $this.offset();
      const x = ((e.pageX - offset.left) / $this.width()) * 100;
      const y = ((e.pageY - offset.top) / $this.height()) * 100;
      // 更新圖片的縮放重心
      $img.css({'transform-origin': `${x}% ${y}%`});
    });
    // 滑鼠移開時重置重心
    $('#productSlider').on('mouseleave', '.swiper-slide', function() {
      $(this).find('img').css('transform-origin', 'center center');
    });
  }

  // 產品內頁-內容tabs
  if ( $('#js-nav-tabs').length != 0 ) {
    const $tabsNavItem = $('#js-nav-tabs').find('.nav-tabs-toggle');
    const $tabsContentWrap = $('#js-tab-content').find('.tab-pane');
    $tabsNavItem.on('click', function() {
      $tabsNavItem.removeClass('active');
      $(this).addClass('active');
      let targetContent = $(this).attr('data-target');
      $tabsContentWrap.removeClass('active');
      $(targetContent).addClass('active');
    });
  }

  // dropdown
  $('.dropdown-btn').on('click', function () {
    const id = $(this).attr('id');
    const dropdown_is_active = $('[aria-labelledby=' + id + ']').hasClass("is-active");
    if (dropdown_is_active >= 1) {
      $('[aria-labelledby=' + id + ']').removeClass('is-active');
      if (window.innerWidth <= 640) {
        $('body').css({
          'height': '',
          'overflow': '',
        })
      }
    } else {
      $(".dropdown-list:not([aria-labelledby=" + id + "]").removeClass('is-active');
      $('[aria-labelledby=' + id + ']').addClass('is-active');
      if (window.innerWidth <= 640) {
        $('body').css({
          'height': '100vh',
          'overflow': 'hidden',
        })
      }
    }
  });

  // accordion
  $('.faqs-accordion .faqs-title').click(function () {
    $(this).parent('.faqs-item').toggleClass('active').siblings().removeClass('active').find('.faqs-content').slideUp(200);
    $(this).siblings('.faqs-content').slideToggle(200);
  });

  $(document).click(function (event) {
    if (!$(event.target).closest('.dropdown-btn').length) {
      if ($('.dropdown-list').is(":visible")) {
        $(".dropdown-list").removeClass('is-active');
        if (window.innerWidth <= 640) {
          $('body').css({
            'height': '',
            'overflow': '',
          })
        }
      }
    }
  });

  // header dropmenu
  const windowWidth = $(window).width();
  if ( windowWidth > 800 ) {
    let $navItems = $('.header-menu-link');
    $navItems.each(function() {
      let itemWidth = $(this).outerWidth();
      let itemLeftOffset = $(this).offset().left;
      let itemRightOffset = windowWidth - (itemLeftOffset + itemWidth);
      // 若右側空間不足, 子選單改成由左開啟 (子選單寬度270px)
      if ( itemRightOffset < 540 ) {
        $(this).addClass('open-to-left');
      }
    });
  }

  // popup
  const $popupWrap = $('#js-custom-popup-content');
  if ( $popupWrap.length!=0 && !Cookies.get('index_popup') ) {
    Swal.fire({
      html: $popupWrap.html(),
      showCloseButton: true,
      closeButtonHtml: '',
      showConfirmButton: false,
      showCancelButton: false,
      focusDeny: false,
      focusClose: false,
      customClass: {
        popup: 'index-popup',
      },
      didOpen: (popup) => {
        popup.focus({ preventScroll: true }); // 將焦點移到彈窗本體（而不是按鈕）
      }
    })
    .then(() => { // popup 關閉後
      Cookies.set('index_popup', 'seen', { expires: 1 })
    });
  }

});

